module.exports = __webpack_public_path__ + "img/hero-image-non-logged-fi.e1186329.png";